export default __webpack_public_path__ + "static/media/excelicon.4ec1a9d5.svg";